import { useForm } from 'react-hook-form'
import {
  FormErrorMessage,
  FormLabel,
  FormControl,
  Input,
  Button,
  Grid,
  Image,
  Heading,
  Text,
  Box,
  Stack,
} from '@chakra-ui/react'
import { Lock } from '../icons'
import { useNavigate } from 'react-router-dom'

import okAppkyLogo from '../assets/images/logo-ok-appky.svg'
import { Card, CardBody } from '../components/Card'

interface ResetPasswordFormValues {
  username: string
}

export const ResetPasswordForm = () => {
  const navigate = useNavigate()
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm<ResetPasswordFormValues>()

  const onSubmit = (values: ResetPasswordFormValues) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log(values)
        navigate('/auth/login')
        resolve(true)
      }, 500)
    })
  }

  return (
    <Grid sx={{ maxW: 'loginFormMaxW', m: 'auto', gap: 8, alignContent: 'start' }}>
      <Image src={okAppkyLogo} w={'auto'} maxW="14rem" h={12} m="auto" alt="OK appky" />

      <Card>
        <CardBody>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ display: 'grid', gap: 8 }}>
              <Stack>
                <Heading as="h2" size="md">
                  Obnovit heslo
                </Heading>

                <Text variant="textMuted" fontSize="sm">
                  Pro obnovu hesla prosím zadejte vaše uživatelské jméno. Na Váš e-mail zašleme
                  odkaz s návodem na obnovu hesla.
                </Text>
              </Stack>

              <Box sx={{ display: 'grid', gap: 4 }}>
                <FormControl variant="fullWidth" isInvalid={!!errors.username}>
                  <FormLabel htmlFor="username">Uživatelské jméno</FormLabel>
                  <Input
                    id="username"
                    placeholder="Vaše uživatelské jméno"
                    autoComplete="username"
                    sx={{ w: '100%' }}
                    defaultValue="jnovakova"
                    {...register('username', {
                      required: 'Zadejte uživatelské jméno',
                    })}
                  />
                  <FormErrorMessage>{errors.username && errors.username.message}</FormErrorMessage>
                </FormControl>
              </Box>

              <Box
                sx={{
                  display: 'grid',
                  width: '100%',
                  gridTemplateColumns: 'auto auto',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Button colorScheme="primary" isLoading={isSubmitting} type="submit">
                  <Lock />
                  Obnovit heslo
                </Button>
              </Box>
            </Box>
          </form>
        </CardBody>
      </Card>
    </Grid>
  )
}
